/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';

interface State {
  data?: string;
  error?: DataAPIClientError;
  isProcessing: boolean;
}

interface Result extends State {
  invoke: (orgID: string, name: string, value: string) => void;
}

export default function useDataAPIUpdateOrgSetting(): Result {
  const client = useDataAPIClient();

  const [state, setState] = useState<State>({ isProcessing: false });

  async function invoke(
    orgID: string,
    name: string,
    value: string
  ): Promise<void> {
    setState({ isProcessing: true });

    try {
      const data = await client.updateOrgSetting(orgID, name, value);

      setState({ data, isProcessing: false });
    } catch (error: any) {
      setState({ error, isProcessing: false });
    }
  }

  return { ...state, invoke };
}
